import { FC, SVGProps } from 'react';

export const PlusIcon2: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.58441 7.41559C2.26165 7.41559 2 7.67724 2 8C2 8.32276 2.26165 8.58441 2.58441 8.58441L7.41559 8.58441L7.41559 13.4156C7.41559 13.7383 7.67724 14 8 14C8.32276 14 8.58441 13.7383 8.58441 13.4156L8.58441 8.58441H13.4156C13.7383 8.58441 14 8.32276 14 8C14 7.67724 13.7383 7.41559 13.4156 7.41559H8.58441L8.58441 2.58441C8.58441 2.26165 8.32276 2 8 2C7.67724 2 7.41559 2.26165 7.41559 2.58441L7.41559 7.41559H2.58441Z"
			fill="currentColor"
		/>
	</svg>
);
